// extracted by mini-css-extract-plugin
export default {"card":"word-set-card_card__vwKh8","title":"word-set-card_title__QyxG7"};